import { Api, globalDomain } from "contexts/api";
import {
  Avatar,
  Button,
  Dropdown,
  Menu,
  Modal,
  Switch,
  Typography,
  message,
} from "antd";
import {
  CreditCardOutlined,
  LogoutOutlined,
  SettingOutlined,
  SwapOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { FaRegUserCircle, FaUserCircle } from "react-icons/fa";
import {
  getTheme,
  setProfileLocal,
  setTheme,
  switchProfile,
} from "utils/components";
import { useContext, useEffect, useState } from "react";

import { BsMoon } from "react-icons/bs";
import Flex from "components/shared-components/Flex";
import Icon from "components/util-components/Icon";
import { UserContext } from "../../contexts/auth";
import axios from "axios";
import { connect } from "react-redux";
import { signOut } from "redux/actions/Auth";
import { useAuth } from "contexts/useAuth";
import { useHistory } from "react-router-dom";
import { useThemeSwitcher } from "react-css-theme-switcher";

const menuItem = [
  {
    title: "Minha conta",
    icon: UserOutlined,
    path: "/myaccount/",
  },

  {
    title: "Configurações",
    icon: SettingOutlined,
    path: "/configuration/",
  },
];

export const NavProfile = ({ signOut }) => {
  const { switcher, themes } = useThemeSwitcher();

  const [currentTheme, setCurrentTheme] = useState(getTheme());
  const [laoding, setLoading] = useState(false);
  const [userProfile, setUserProfile] = useState(false);
  const history = useHistory();
  const { user, setUser, setProfile } = useContext(UserContext);
  const [visible, setVisible] = useState(false);

  const getUser = async () => {
    setLoading(true);
    try {
      const { data: res } = await Api.get(`/api/profile`);
      setUserProfile(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => getUser(), []);

  const toggleTheme = (isChecked) => {
    const changedTheme = isChecked ? "dark" : "light";

    setTheme(changedTheme);
    setCurrentTheme(changedTheme);
    switcher({ theme: themes[changedTheme] });
  };

  const { logout } = useContext(UserContext);

  const { ...auth } = useAuth();

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };




  const logged = user ? user?.filter((item) => item?.hash === auth?.profile?.franchise_id)[0] : false

  const profileMenu = (
    <div
      className="nav-profile nav-dropdown"
      style={{ maxWidth: "300px", width: "100%", minWidth: "250px" }}
    >
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar
            size={45}
            src={
              userProfile?.profile_pic
                ? `${globalDomain}/upload/${userProfile?.profile_pic}`
                : "/img/avatars/thumb-2.jpg"
            }
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/img/avatars/thumb-2.jpg";
            }}
            style={{ marginRight: "1em" }}
          />
          <div className="pl-3">
            <Flex alignItems="center" justifyContent="between">
              <h5 className="mb-0">{auth.profile?.user ?? "Usuário"}</h5>
              {auth?.user &&
                auth?.user?.filter(
                  (item) => item?.hash === auth?.profile?.franchise_id
                )[0]?.roles?.length > 1 && (
                  <Button
                    shape={"circle"}
                    style={{ marginLeft: "2.5em" }}
                    icon={
                      <SwapOutlined
                        onClick={() => {
                          setVisible(true);
                        }}
                      />
                    }
                  ></Button>
                )}
            </Flex>
            <span className="text-muted">
              {auth?.profile?.title ?? "Administrador"}
            </span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <a href={el.path}>
                  <Icon type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </a>
              </Menu.Item>
            );
          })}
          <Menu.Item
            key={menuItem.length + 3}
            onClick={() => {
              new Promise((resolve, reject) => {
                resolve(switchProfile());
                setProfile(false);
              }).then(() => {
                history.push("/login");
              });
            }}
          >
            <span>
              <SwapOutlined
                fontSize={19}
                style={{ marginRight: "0.4em", marginBottom: "-4px" }}
              />
              <span className="font-weight-normal">Trocar de conta</span>
            </span>
          </Menu.Item>
          <Menu.Item key={menuItem.length + 2}>
            <span>
              <BsMoon
                fontSize={19}
                style={{ marginRight: "0.4em", marginBottom: "-4px" }}
              />
              <span className="font-weight-normal">Modo noturno</span>

              <Switch
                checked={currentTheme === "dark"}
                onChange={toggleTheme}
                style={{ float: "right", top: "6px" }}
              />
            </span>
          </Menu.Item>
          <Menu.Item key={menuItem.length + 1} onClick={logout}>
            <span>
              <LogoutOutlined />
              <span className="font-weight-normal">Sair</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
      <Modal
        centered
        visible={visible}
        width={400}
        cancelButtonProps={{ style: { display: "none" } }}
        onCancel={handleCancel}
        onOk={handleOk}
        okButtonProps={{ style: { display: "none" } }}
      >
        <Typography style={{ marginBottom: "1em" }}>
          Selecione um perfil de acesso
        </Typography>

        {logged ? logged.roles?.filter(item => item?.id !== auth?.profile?.role_id)
          .map((profile) => {
            return (
              <>
                <div
                  className="profile-item"
                  onClick={async () => {
                    const franchise = auth.user?.filter(
                      (item) => item.hash === auth.profile.franchise_id
                    )[0];

                    const perfil = {
                      role: profile.title,
                      role_id: profile.id,
                      franchise_id: franchise.hash,
                      franchise_name: franchise.company,
                      name: profile.name,
                      type: franchise.type_company,
                      nickname: franchise.nickname,
                      user: profile.user,
                    };


                    try {
                      axios.defaults.headers.post[
                        "Access-Control-Allow-Origin"
                      ] = "true";

                      const { role_id, franchise_id } = perfil;

                      const { data } = await Api.post(
                        `/authenticate-as`,
                        {
                          role_id,
                          franchise_hash: franchise.hash,
                        },
                        {
                          withCredentials: true,
                          xsrfCookieName: "XSRF-TOKEN",
                          xsrfHeaderName: "X-XSRF-TOKEN",
                        }
                      );

                      perfil.abilities = data.abilities;

                      auth.setProfile({ ...perfil, role_id, user: data.user });
                      setProfileLocal({ ...perfil, role_id, user: data.user });

                      message.success("Perfil alterado com sucesso!");
                      setVisible(false);
                    } catch (error) {
                      message.error("Erro ao tentar alterar o perfil");
                    }
                  }}
                >
                  <FaUserCircle fontSize={23} />
                  <div className="profile-item-info">
                    <Typography>{profile.title}</Typography>
                    <span>{profile.role}</span>
                  </div>
                </div>
              </>
            );
          }) : null}
      </Modal>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item key="profile">
          <Avatar
            src={
              userProfile?.profile_pic
                ? `${globalDomain}/upload/${userProfile?.profile_pic}`
                : "/img/avatars/thumb-2.jpg"
            }
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/img/avatars/thumb-2.jpg";
            }}
          />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
};

export default connect(null, { signOut })(NavProfile);
